import React, { useState, useEffect } from 'react'
import { get } from 'lodash'

import Select from '../../select'
import Input from '../../input'

const { Option } = Select

export default (props) => {
  const { options = [], addonBeforeStyle, ...inputProps } = props
  const [items, setItems] = useState(options)
  const getInitialKey = () => {
    let key = get(options, '0.value')

    if (inputProps.value) {
      key = get(Object.keys(inputProps.value), '0') || key
    }

    return key
  }
  const [key, setKey] = useState(getInitialKey())
  const onKeyChange = (key) => {
    setKey(key)
    props.onChange({
      [key]: '',
    })
  }
  const onChange = (evt) => {
    props.onChange({
      [key]: evt.target.value,
    })
  }
  const addonBefore = (
    <Select
      value={key}
      onChange={onKeyChange}
      style={{
        width: '120px',
        ...addonBeforeStyle,
      }}
    >
      {items.map(({ label, value }) => (
        <Option key={value} value={value}>
          {label}
        </Option>
      ))}
    </Select>
  )
  const getInputValue = () => {
    return get(inputProps.value, key)
  }

  useEffect(() => {
    setItems(options)
    setKey(getInitialKey())
  }, [options, inputProps.value])

  return (
    <Input {...inputProps} value={getInputValue()} addonBefore={addonBefore} onChange={onChange} />
  )
}
